import FormGroup from "@mui/material/FormGroup"
import Switch from "@mui/material/Switch"
import { observer } from "mobx-react-lite"
import useStore from "reusable/mobx-store-utils"
import { formHandler, FormHandlerConfig } from "reusable/mobx-store-utils/form-handlers/new/form-handler"
import { useProposalsEditPaymentStore } from "../ProposalsEditPaymentStore"
import { ServiceRateTypeEnum } from "@gap/backend/app-services/services/models/ServiceRateTypesDto"
import { ProposalStep3AllExtraAttributesDto, ProposalStep3AllAttributesDto } from "@gap/backend/app-services/proposal/models/ProposalStep3Dto"
import { notNull, PickByValue } from "@gap/utils/utils"

interface ProposalsEditPaymentBlockCheckProps {
   rateType: ServiceRateTypeEnum
   fieldName: keyof PickByValue<ProposalStep3AllExtraAttributesDto, boolean>
}

export default observer(function ProposalsEditPaymentBlockCheck({ rateType, fieldName }: ProposalsEditPaymentBlockCheckProps) {
   const proposalEditPaymentStore = useProposalsEditPaymentStore()
   const stepData = proposalEditPaymentStore.getStepByRateType(rateType) as ProposalStep3AllAttributesDto

   const localStore = useStore(() => ({
      fields: {
         checkValue: stepData[fieldName]
      },
      get formHandler() {
         return formHandler(localStore.fields, {
            checkValue: { type: 'boolean', onValueChange: localStore.updateProposal },
         } satisfies FormHandlerConfig)
      },
      updateProposal: async () => {
         if (stepData && fieldName in stepData) {
            stepData[fieldName] = notNull(localStore.fields.checkValue)
            await proposalEditPaymentStore.update()
         }
      }
   }))

   if (!stepData) {
      return null
   }

   return <FormGroup>
      {
         localStore.formHandler.checkValue.bindInput(ip => {
            return <Switch checked={ip.checked} onChange={ip.onChange} />
         })
      }
   </FormGroup>
})
